import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import { reduxStore } from "./lib/redux/store";
import { ToastContainer } from "react-toastify";

ReactDOM.render(
  <Provider store={reduxStore}>
    <ToastContainer />
    <BrowserRouter>
      <App />
      <ScrollToTop />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
